import React from 'react'
import ReportIcon from '@/assets/report/ReportIcon.svg'

const Grid: React.FC = () => {
    return (
        <div className="relative flex-col items-center justify-center h-full hidden md:flex lg:flex xl:flex 2xl:flex">
            <img src={ReportIcon} alt="ReportIcon" className="z-10 w-[140px]" />
        </div>
    )
}

export default Grid